import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import cookie from "js-cookie";
import vailcode from "@utils/errcode";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      formData: {},
      isSubmit: false
    };
  },
  watch: {
    "$parent.popRefShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.formData = Object.assign({}, this.$parent.modifyData);
        } else {
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      let rs = await this.$http.post("/referral/modify", this.formData);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.list = rs.data;
        this.$parent.popRefShow = false;
      });
    }
  }
};